import React, { useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Grid2,
  Typography,
  useTheme,
  Button,
  Skeleton,
} from "@mui/material";
import { ArrowOutward } from "@mui/icons-material";
import { IoIosHappy } from "react-icons/io";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useGetRiskKPIQuery } from "../../../store/slices/apis/riskDashboardSlice";
import RiskPopup from "./RiskPopup";
import { useParams } from "react-router-dom";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import ProjectStatusOverviewHead from "components/ProjectStatusOverviewHead";
import { ReactComponent as ArrowIcon } from "assets/PwC_Funct_Icons_ArrowIncrease_Outline_Black_RGB.svg"
import { ReactComponent as ArrowUpIcon } from "assets/PwC_Funct_Icons_ArrowUp_Outline_Black_RGB.svg"
import { ReactComponent as ArrowDownIcon } from "assets/PwC_Funct_Icons_ArrowDown_Outline_Black_RGB.svg"

const kpiData = [
  {
    title: "Total Active Risk",
    value: "totalNumberTotalActive",
    change: "growthPercentageTotalActiveFromLastMonth",
    iconColor: "#E0F0E4",
    dotColor: "#CE412D",
    textColor: "#377E36",
    status: "Open",
    timeFrame: "this month",
    color: "#9ED3CC",
    showChange: "",
  },
  {
    title: "No. Unmitigated Risk",
    value: "totalNumberNoUnmitigated",
    change: "growthPercentageNoUnmitigatedFromLastMonth",
    iconColor: "#E0F0E4",
    dotColor: "#CE412D",
    textColor: "#377E36",
    status: "Unmitigated",
    timeFrame: "this month",
    color: "#9ED3CC",
    showChange: "",
  },
  {
    title: "Closed Risk",
    value: "totalNumberClosed",
    change: "growthPercentageClosedFromLastMonth",
    iconColor: "#E0F0E4",
    textColor: "#377E36",
    dotColor: "#CE412D",
    status: "Close",
   color: "#9ED3CC",
    timeFrame: "this month",
    showChange: "",
  },
  {
    title: "Risks w/Actions",
    value: "totalNumberWithAction",
    change: "growthPercentageWithActionFromLastMonth",
    iconColor: "#E0F0E4",
    dotColor: "#CE412D",
    textColor: "#377E36",
    status: "WithActions",
    timeFrame: "this month",
   color: "#9ED3CC",
    showChange: "",
  },
  // {
  //     title: "Inherent Risk",
  //     value: "totalInherentRisk",
  //     change: "growthPercentageInherentRiskFromLastMonth",
  //     iconColor: "#E0F0E4",
  //     textColor: '#377E36',
  //     dotColor: '#CE412D',
  //     status: 'Inherent',
  //     timeFrame: 'this month',
  //     color: '#CDFBE7'
  // },
  // {
  //     title: "Target Risk Rating",
  //     value: 6,
  //     iconColor: "#E0F0E4",
  //     dotColor: '#CE412D',
  //     textColor: '#377E36',
  //     color: '#CDFBE7',

  // },
];

const RiskKPI = () => {
  const { projectId } = useParams();
  const [popupData, setPopupData] = useState(null);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const {
    data: RiskKPI = [],
    error,
    isLoading,
  } = useGetRiskKPIQuery({
    project_id: projectId,
  });

  const lastUpdated = RiskKPI?.data?.lastUpdated;

  const riskKPIData = kpiData.map((item, index) => {
    let value, change, arrow;
    let isPositive = false;

    if (index < 5) {
      value = RiskKPI?.data?.[item.value] ?? "-";
      const changeValue = parseFloat(RiskKPI?.data?.[item.change]);
      //isPositive = !isNaN(changeValue) && changeValue >= 0;
      //   change = isNaN(changeValue)
      //     ? "-"
      //     : `${changeValue >= 0 ? "+" : ""}${changeValue}%`;

      arrow = `${changeValue >= 0 ? "up" : "down"}`;

      change = isNaN(changeValue)
        ? "-"
        : changeValue === -100
          ? "0%"
          : `${Math.abs(changeValue)}%`;

      if (item.status === "Close") {
        isPositive = !isNaN(changeValue) && changeValue > 0;
      } else if (
        item.status === "Open" ||
        item.status === "Unmitigated" ||
        item.status === "WithActions"
      ) {
        isPositive = !isNaN(changeValue) && changeValue < 0;
      }
    } else {
      value = item.value;
      change = "-";
      isPositive = true;
    }

    return {
      ...item,
      value,
      change,
      isPositive,
      arrow,
    };
  });

  if (isLoading) {
    return (
      <Box
        sx={{
          padding: "15px 25px 25px 25px",
          background: "#fff",
          borderRadius: 2,
          mb: 2,
          marginTop: "10px",
        }}
      >
        <Skeleton variant="text" width={120} height={30} sx={{ mb: 2 }} />

        <Grid2 container spacing={2}>
          {[...Array(6)].map((_, index) => (
            <Grid2 size={{ xs: 12, md: 6, sm: 12, xl: 6 }} key={index}>
              <Card
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                  borderRadius: "8px",
                  boxShadow: "none",
                  backgroundColor: "#f3f3f3",
                }}
              >
                <Box width="100%">
                  <Skeleton
                    variant="text"
                    width="40%"
                    height={20}
                    sx={{ mb: 1 }}
                  />
                  <Box display="flex" alignItems="center" gap={1}>
                    <Skeleton variant="text" width={60} height={30} />
                    <Skeleton variant="text" width={50} height={30} />
                  </Box>
                </Box>
              </Card>
            </Grid2>
          ))}
        </Grid2>
      </Box>
    );
  }

  return (
    <>
      <Grid2 container rowSpacing={1.25} columnSpacing={3} sx={{ mt: "4px" }}>
        <ProjectStatusOverviewHead
          lastModified={lastUpdated}
          marginBottm={"20px"}
        />

        {riskKPIData.map((card, index) => (
          <Grid2 size={{ xs: 12, md: 3 }}>
            <Card
              sx={{
                boxShadow: "none",
                border: "1px solid #25252517",
                borderRadius: "3px",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ pl: "20px", pr: "20px", pt: "17px", pb: "17px" }}
              >
                <Box display="flex" alignItems="center" sx={{ mr: 0 }}>
                  <Typography
                    sx={{
                      bgcolor: card.color,
                      width: "45px",
                      height: "45px",
                      mr: 2,
                    }}
                  />
                  <Box>
                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 700,
                          fontSize: "18px",
                          mr: 1,
                          color: card.valueColor,
                        }}
                      >
                        {card.value}
                      </Typography>
                      {card.status && (
                        <Chip
                          label={card.change}
                          size="small"
                          icon={
                            card.change !== "0%" &&
                            // (card.arrow === "up" ? (
                            //   <ArrowUpward
                            //     sx={{
                            //       fontSize: "12px !important",
                            //       color: card.isPositive
                            //         ? `${card.textColor} !important`
                            //         : `${card.dotColor} !important`,
                            //     }}
                            //   />
                            // ) : (
                            //   <ArrowDownward
                            //     sx={{
                            //       fontSize: "12px !important",
                            //       color: card.isPositive
                            //         ? `${card.textColor} !important`
                            //         : `${card.dotColor} !important`,
                            //     }}
                            //   />
                            // ))
                            (
                              card.arrow === "up" ? (
                                <ArrowUpIcon
                                  style={{
                                    height: "12px",
                                    width: "12px",
                                    fill: card.isPositive ? card.textColor : card.dotColor,
                                  }}
                                />
                              ) : (
                                <ArrowDownIcon
                                  style={{
                                    height: "12px",
                                    width: "12px",
                                    fill: card.isPositive ? card.textColor : card.dotColor,
                                  }}
                                />
                              )
                            )

                          }
                          sx={{
                            backgroundColor: card.iconColor,
                            color:
                              card.isPositive === false
                                ? card.change === "0%"
                                  ? card.textColor
                                  : card.dotColor
                                : card.textColor,
                            fontWeight: 500,
                            fontSize: "12px",
                            borderRadius: "4px",
                          }}
                        />
                      )}

                      <Typography
                        variant="body2"
                        color="#474747"
                        sx={{
                          ml: "2px",
                          fontWeight: 400,
                          fontSize: "13px",
                          lineHeight: "24px",
                        }}
                      >
                        {card.timeFrame}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: "5px",
                        lineHeight: "100%",
                        letterSpacing: "-0.4px",
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#252525",
                      }}
                    >
                      {card.title}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  {card.status && (
                    <Avatar
                      sx={{
                        bgcolor: "#fff",
                        width: "37px",
                        height: "37px",
                        border: "1px solid #d3d3d3",
                      }}
                    >
                      {/* <MdOutlineArrowOutward
                                              style={{
                                                color: "#252525",
                                                fontSize: "20px",
                                                cursor: "pointer",
                                               
                                              }}
                                              onClick={() => {
                                                setPopupData(card);
                                                setOpen(true);
                                              }}
                                            /> */}
                      <ArrowIcon
                        style={{
                          color: "#252525",
                          fontSize: "20px",
                          cursor: "pointer",
                          height: "13px",
                          stroke: "#252525",
                          strokeWidth: "6"
                        }}
                        onClick={() => {
                          setPopupData(card);
                          setOpen(true);
                        }}
                      />
                    </Avatar>
                  )}
                </Box>
              </Box>
            </Card>
          </Grid2>
        ))}
      </Grid2>

      {open && (
        <RiskPopup
          title={popupData.title}
          value={popupData.value}
          status={popupData.status}
          onOpen={open}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default RiskKPI;
